import React from 'react';

import MomentUtils from '@date-io/moment';
import moment from 'moment';
import 'moment/locale/pt-br';

import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { StylesProvider, ThemeProvider, jssPreset } from '@material-ui/styles';
import { makeStyles } from '@material-ui/core';
import { create } from 'jss';
import 'typeface-roboto';

const jss = create({
    plugins: jssPreset().plugins,
});

function MuiProvider({ theme, children }) {
    useStyles();
    return (
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
            <StylesProvider jss={jss}>
                <ThemeProvider theme={theme}>{children}</ThemeProvider>
            </StylesProvider>
        </MuiPickersUtilsProvider>
    );
}

const useStyles = makeStyles(({ spacing }) => ({
    '@global': {
        // Firefox
        'input[type=number]': {
            '-moz-appearance': 'textfield',
        },
        // Chrome, Safari, Edge, Opera
        'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
            margin: 0,
            '-webkit-appearance': 'none',
        },
        // width
        '::-webkit-scrollbar': {
            width: spacing(1),
        },
        // Track
        '::-webkit-scrollbar-track': {
            background: '#f1f1f1',
        },
        // Handle
        '::-webkit-scrollbar-thumb': {
            background: '#888',
        },
        // Handle on hover
        '::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
    },
}));

export default MuiProvider;
